import { render, staticRenderFns } from "./videoOptionsInput.vue?vue&type=template&id=276e80a2&scoped=true&lang=pug&"
import script from "./videoOptionsInput.vue?vue&type=script&lang=js&"
export * from "./videoOptionsInput.vue?vue&type=script&lang=js&"
import style0 from "./videoOptionsInput.vue?vue&type=style&index=0&id=276e80a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e80a2",
  null
  
)

export default component.exports